const stages = {
    LOCAL: 'LOCAL',
    PRODUCTION: 'PRODUCTION',
    STAGING: 'STAGING',
    DEMO: 'DEMO',
    DEV: 'DEV',
};

export default stages;
